import { FC, ReactNode } from 'react';
import { cn } from '@fe-learner-common';

interface EmptyStateProps {
  icon?: ReactNode;
  label: string;
  description: string;
}

const Row = ({ icon, className }: { icon: ReactNode; className?: string }) => {
  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-lg bg-neutral-100 p-2',
        className,
      )}
    >
      {icon}
      <div className="flex flex-1 flex-col">
        <div className="h-1 w-12 rounded-sm bg-neutral-550" />
        <div className="mt-1 h-1 w-full rounded-sm bg-neutral-550" />
      </div>
    </div>
  );
};

export const EmptyState: FC<EmptyStateProps> = ({
  icon,
  label,
  description,
}) => {
  return (
    <div className="flex flex-col items-center gap-10 p-10">
      <div className="flex w-[240px] flex-1 flex-col gap-1">
        <Row icon={icon} />
        <Row icon={icon} className="opacity-60" />
        <Row icon={icon} className="opacity-30" />
      </div>
      <div className="flex flex-col gap-4 text-center">
        {label && <h2 className="text-title-md">{label}</h2>}
        {description && (
          <p className="text-body-md text-neutral-500">{description}</p>
        )}
      </div>
    </div>
  );
};

interface EmptyStateWrapperProps extends EmptyStateProps {
  children: ReactNode;
  condition?: boolean | null;
}

export const EmptyStateWrapper: FC<EmptyStateWrapperProps> = ({
  children,
  condition,
  ...rest
}) => {
  return condition ? children : <EmptyState {...rest} />;
};
